import React, { Component } from 'react';
import { Button, Card, Form, Input, message, Select, Tabs } from 'antd';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import util from '@util/index';
import {
  queryExportIncuOregistappListByInc,
  queryIncuOregistappListByInc,
} from '@api/incubator/oregistapp';
import { queryAddressBusinessStatis } from '@api/incubator/address';

import Statistic from '@comm/statistic/Index';
import { setBackInfo } from '@store/modules/back_info';
import TableOut from './TableOut';
import TableUsing from './TableUsing';

const { TabPane } = Tabs;
const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      outList: [],
      usingList: [],
      statistic: {},

      outCurrent: 1,
      usingCurrent: 1,

      outLoading: false,
      usingLoading: false,

      outPagination: {},
      usingPagination: {},

      outPageSize: 10,
      usingPageSize: 10,
      exportLoading: false,

      type: '2',
      tabKey: '0',
      condition: '',
    };
  }

  componentDidMount() {
    const { backInfo } = this.props;
    if (backInfo.pathname === this.props.location.pathname) {
      this.setState(
        {
          type: backInfo.type,
          tabKey: backInfo.tabKey,
          outPageSize: backInfo.outPageSize,
          usingPageSize: backInfo.usingPageSize,
          condition: backInfo.condition,
          outCurrent: backInfo.outCurrent,
          usingCurrent: backInfo.usingCurrent,
        },
        () => {
          backInfo.tabKey === '0' && this.loadData(0);
          backInfo.tabKey === '1' && this.loadData(1);
        },
      );
    } else {
      this.loadData(0);
    }
    this.getAddressBusinessStatis(this.props.params.uuid);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.uuid !== this.props.params.uuid) {
      this.loadData(0, nextProps.params.uuid);
      this.loadData(1, nextProps.params.uuid);
      this.getAddressBusinessStatis(nextProps.params.uuid);
    }
  }

  componentWillUnmount() {
    const {
      type,
      tabKey,
      condition,
      outCurrent,
      outPageSize,
      usingCurrent,
      usingPageSize,
    } = this.state;
    const {
      location: { pathname },
    } = this.props;
    const params = {
      type,
      tabKey,
      pathname,
      condition,
      outCurrent,
      outPageSize,
      usingCurrent,
      usingPageSize,
    };
    this.props.dispatch(setBackInfo(params));
  }

  getAddressBusinessStatis = uuid => {
    queryAddressBusinessStatis({
      incubatorUuid: uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          statistic: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  loadData = (usingStatus, uuid) => {
    let { incuUuid } = this.props;
    const { type, condition, usingCurrent, outCurrent, usingPageSize, outPageSize } = this.state;
    if (uuid) {
      incuUuid = uuid;
    }

    usingStatus ? this.setState({ outLoading: true }) : this.setState({ usingLoading: true });

    const params = {};
    params.incubatorUuid = incuUuid;
    params.usingStatus = usingStatus;

    params.type = type === '2' ? '' : type;
    params.limit = usingStatus ? outPageSize : usingPageSize;
    params.condition = condition;
    params.start = usingStatus ? outCurrent : usingCurrent;

    queryIncuOregistappListByInc(params).then(res => {
      if (res.statusCode === 200) {
        usingStatus
          ? this.setState({
              outList: res.data,
              outPagination: {
                pageSize: outPageSize,
                current: outCurrent,
                total: res.totalSize,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                showQuickJumper: true,
              },
            })
          : this.setState({
              usingList: res.data,
              usingPagination: {
                pageSize: usingPageSize,
                current: usingCurrent,
                total: res.totalSize,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                showQuickJumper: true,
              },
            });
      } else {
        message.error(res.message);
      }
      usingStatus ? this.setState({ outLoading: false }) : this.setState({ usingLoading: false });
    });
  };

  export = usingStatus => {
    const { incuUuid } = this.props;
    const { type, condition, usingCurrent, outCurrent, usingPageSize, outPageSize } = this.state;

    const params = {};
    params.incubatorUuid = incuUuid;
    params.usingStatus = usingStatus;

    params.type = type === '2' ? '' : type;
    params.limit = usingStatus ? outPageSize : usingPageSize;
    params.condition = condition;
    params.start = usingStatus ? outCurrent : usingCurrent;

    this.setState({ exportLoading: true });
    queryExportIncuOregistappListByInc(params).then(r => {
      this.setState({ exportLoading: false });
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition, type } = this.state;
    return (
      <Form
        onSubmit={this.handleSubmit}
        style={{
          display: 'flex',
          position: 'absolute',
          top: '0',
          right: '10px',
          zIndex: 100,
        }}
      >
        <FormItem>
          {getFieldDecorator('type', {
            initialValue: type,
            getValueFromEvent: this.handleChangeType,
          })(
            <Select placeholder="交易类型" style={{ width: '130px', marginRight: '15px' }}>
              <Select.Option value="2">全部</Select.Option>
              <Select.Option value="0">免费注册</Select.Option>
              <Select.Option value="1">收费注册</Select.Option>
            </Select>,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('name', {
            initialValue: condition,
          })(<Input placeholder="请输入客户名称" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" style={{ marginLeft: '10px' }}>
            搜索
          </Button>
          <Button
            icon="export"
            style={{ marginLeft: '10px' }}
            onClick={() => this.export(this.state.tabKey)}
            loading={this.state.exportLoading}
          >
            导出
          </Button>
        </FormItem>
      </Form>
    );
  };

  handleChangeType = e => {
    this.setState(
      {
        type: e,
        usingCurrent: 1,
        outCurrent: 1,
      },
      () => {
        this.loadData(0);
        this.loadData(1);
      },
    );
    return e;
  };

  // 搜索
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.name,
          },
          () => {
            this.loadData(0);
            this.loadData(1);
          },
        );
      }
    });
  };

  changeUsingTable = pagination => {
    this.setState(
      {
        usingCurrent: pagination.current,
        usingPageSize: pagination.pageSize,
      },
      () => {
        this.loadData(0);
      },
    );
  };

  changeOutTable = pagination => {
    this.setState(
      {
        outCurrent: pagination.current,
        outPageSize: pagination.pageSize,
      },
      () => {
        this.loadData(1);
      },
    );
  };

  hangleChangeTabs = key => {
    const { usingList, outList } = this.state;
    key === '0' && usingList.length === 0 && this.loadData(0);
    key === '1' && outList.length === 0 && this.loadData(1);
    this.setState({
      tabKey: key,
    });
  };

  render() {
    const {
      statistic,
      tabKey,
      outList,
      usingList,
      outLoading,
      usingLoading,
      outPagination,
      usingPagination,
    } = this.state;
    const uuid = this.props.params.uuid || ''; // 孵化器uuid
    return (
      <Card
        title="地址管理"
        extra={<Link to={`/incubator/one/${uuid}/contract/address`}>地址注册申请</Link>}
      >
        <Statistic
          data={[
            {
              title: '使用率',
              value: `${util.numberFormat(statistic.usageRate || 0)}%`,
            },
            {
              title: '地址总数',
              value: statistic.sum || 0,
            },
            {
              title: '在用地址数',
              value: statistic.isUsed || 0,
            },
            {
              title: '免费注册',
              value: statistic.free || 0,
            },
            {
              title: '收费注册',
              value: statistic.cost || 0,
            },
          ]}
        />
        <div
          style={{
            position: 'relative',
          }}
        >
          {this.renderSearchForm()}
          <Tabs defaultActiveKey="0" activeKey={tabKey} onChange={this.hangleChangeTabs}>
            <TabPane tab="在用地址" key="0">
              <TableUsing
                data={usingList}
                isLoading={usingLoading}
                pagination={usingPagination}
                onChange={this.changeUsingTable}
                {...this.props}
              />
            </TabPane>
            <TabPane tab="迁出记录" key="1">
              <TableOut
                data={outList}
                isLoading={outLoading}
                pagination={outPagination}
                onChange={this.changeOutTable}
                {...this.props}
              />
            </TabPane>
          </Tabs>
        </div>
      </Card>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/incubator/oregistapp/Index.js